module.exports = __webpack_public_path__ + "img/logo.4d621d57.svg";